import { Modal } from '@mui/material';
import React from 'react';

const ReusableModal = ({ width,height,open, onClose, children }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: width,
          maxHeight: height,
          overflowY: "auto",
          overflowX: "auto",
          backgroundColor: "#F9FBFC",
          boxShadow: 24,
          padding: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "flex-end",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img style={{ width: 20, height: 20 }} src="/Close.png" alt="close" />
        </div>
        {children}
      </div>
    </Modal>
  );
};

export default ReusableModal;
